import React from "react";

class ModalNoticeOverlay extends React.Component {

    render() {
        return (
            <div className="modal-notice-overlay">
                <div className="modal-notice">
                    <div className="modal-notice-main">
                        <div className="modal-notice-centered">
                            <h4>Before you continue, please understand that:</h4>
                            <ul>
                                <li>This website is run by a private company. We have no connection to U.S. Citizenship
                                    and Immigration Services (USCIS) or any other government agency.
                                </li>
                                <li><strong>YOU</strong> must send your completed government forms directly to the USCIS
                                    or other government agency. We don’t do that for you.
                                </li>
                                <li><strong>YOU</strong> must pay any required fees directly to the USCIS or other
                                    government agency. We don’t do that for you.
                                </li>
                            </ul>

                            <div className="modal-notice-cta-box">
                                <label className="modal-notice-cta">
                                    <input id="modal-notice-checkbox" type="checkbox" className="void" />
                                        <span className="void"></span>
                                </label>
                                <span className="modal-notice-cta-label">OK</span>
                                <div className="modal-notice-error">(must click checkbox to proceed)</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default ModalNoticeOverlay;